import { createSlice } from "@reduxjs/toolkit";
import { DashboardSVG, BalanceSVG, TransactionSVG, ProductSVG, ChannelSVG } from "src/assets/svg";
import Maxim from "src/assets/img/maxim.png";
import Ovo from "src/assets/img/ovo.png";
import Pln from "src/assets/img/pln.png";
import Telkomsel from "src/assets/img/telkomsel.png";
import Threelogo from "src/assets/img/threelogo.png";
import SukaMajuJakarta from "src/assets/img/sukamajujakarta.png";
import SukaMajuBogor from "src/assets/img/sukamajubogor.png";
import Anton from "src/assets/img/anton.png";
import SusiSusanti from "src/assets/img/susisusanti.png";
import TokoDepok from "src/assets/img/tokopulsadepok.png";

const SvgList = (menu, fill) => {
  switch (menu.title) {
    case "Dashboard":
      return <DashboardSVG fill={fill} />;
    case "Balance":
      return <BalanceSVG fill={fill} />;
    case "Transaction":
      return <TransactionSVG fill={fill} />;
    case "Product":
      return <ProductSVG fill={fill} />;
    case "Channel":
      return <ChannelSVG fill={fill} />;
    default:
      return null;
  }
};

export const globalSlice = createSlice({
  name: "global",
  initialState: {
    menus: [
      {
        choosen: true,
        image: <DashboardSVG fill="#545DFF" />,
        title: "Dashboard",
      },
      {
        choosen: false,
        image: <BalanceSVG fill="#7A7A7A" />,
        title: "Balance",
      },
      {
        choosen: false,
        image: <TransactionSVG fill="#7A7A7A" />,
        title: "Transaction",
      },
      {
        choosen: false,
        image: <ProductSVG fill="#7A7A7A" />,
        title: "Product",
      },
      {
        choosen: false,
        image: <ChannelSVG fill="#7A7A7A" />,
        title: "Channel",
      },
    ],
    chartData: [
      {
        name: "04 Apr 22",
        users: 2700000,
      },
      {
        name: "06 Apr 22",
        users: 4200000,
      },
      {
        name: "08 Apr 22",
        users: 2200000,
      },
      {
        name: "10 Apr 22",
        users: 5000000,
      },
    ],
    isLoading: false,
    products: [
      {
        image: Maxim,
        title: "Maxim",
        description: "150.000",
        total: "120",
        explanation: "transactions",
      },
      {
        image: Telkomsel,
        title: "Telkomsel",
        description: "25.000",
        total: "98",
        explanation: "transactions",
      },
      {
        image: Threelogo,
        title: "Three",
        description: "50.000",
        total: "74",
        explanation: "transactions",
      },
      {
        image: Ovo,
        title: "Ovo",
        description: "100.000",
        total: "68",
        explanation: "transactions",
      },
      {
        image: Pln,
        title: "PLN Postpaid",
        total: "50",
        explanation: "transactions",
      },
    ],
    agents: [
      {
        image: SukaMajuJakarta,
        title: "PT Suka Maju Jakarta",
        profits: "Rp 3.700.000",
        sales: "Rp 7.320.000 ",
        transaction: "43 transactions",
      },
      {
        image: SusiSusanti,
        title: "Susi Susanti",
        profits: "Rp 3.550.000",
        sales: "Rp 5.230.000 ",
        transaction: "37 transactions",
      },
      {
        image: TokoDepok,
        title: "Toko Pulsa III Depok",
        profits: "Rp 2.860.000",
        sales: "Rp 4.500.000 ",
        transaction: "38 transactions",
      },
      {
        image: SukaMajuBogor,
        title: "PT Suka Maju Bogor",
        profits: "Rp 2.400.000",
        sales: "Rp 4.800.000 ",
        transaction: "40 transactions",
      },
      {
        image: Anton,
        title: "Anton Antoman",
        profits: "Rp 2.350.000",
        sales: "Rp 2.100.000 ",
        transaction: "20 transactions",
      },
    ],
  },
  reducers: {
    getDataFetch: (state) => {
      state.isLoading = true;
    },
    chooseMenu: (state, action) => {
      const { index } = action.payload;
      state.menus = state.menus.map((menu, idx) => {
        if (index === idx) {
          return {
            ...menu,
            choosen: true,
            image: SvgList(menu, "#545DFF"),
          };
        } else {
          return {
            ...menu,
            choosen: false,
            image: SvgList(menu, "#7A7A7A"),
          };
        }
      });
    },
    getDataFailure: (state) => {
      state.isLoading = false;
    },
  },
});

export const { getDataFetch, chooseMenu, getDataFailure } = globalSlice.actions;
export default globalSlice.reducer;
